import { authClient } from '../auth/client'
import { queryClient } from '../query'

export const getLoggedInUser = async () => {
  const { data: session } = await queryClient.ensureQueryData({
    queryFn: () => authClient.getSession(),
    queryKey: ['auth-session'],
    staleTime: 1000 * 60 * 2,
    revalidateIfStale: true,
  })

  return {
    session,
    isLoggedIn: session?.session !== undefined,
  }
}
